import { useProductionStore } from "../../../stores/production";

const DetailsOfService = () => {
  const { production2 } = useProductionStore();

  // Récupere tous les utilisateurs uniques
  const users: string[] =
    production2?.customerFiles
      ?.map((customer: any) =>
        customer?.missions.map((mission: any) =>
          mission?.collaborators?.map((collab: any) => collab.name)
        )
      )
      .flat(2) ?? [];

  const uniqueUsers = [...new Set(users)];

  return (
    <div className="space-y-8 w-full h-full mt-5">
      {production2?.customerFiles?.map((row: any) => (
        <div key={row.id} className="space-y-6">
          <h2 className="text-xl font-bold text-left">{row.name}</h2>
          
          {row?.missions?.map((mission: any, missionIndex: number) => (
              <table className="min-w-full font-Nunito bg-white shadow-lg border border-gray-100 rounded-2xl min-h-full h-[80%] mt-5 overflow-x-scroll overflow-y-scroll" id={mission.id}>
                <thead className="w-full py-4 text-left">
                  <tr>
                    <th className="border border-gray-300 px-4 py-2 bg-thead text-left w-10">
                     {mission.name}
                    </th>
                    {uniqueUsers?.map((user) => (
                      <th
                        key={user}
                        className="border border-gray-300 px-4 py-2 bg-thead text-left w-10"
                      >
                        {user}
                      </th>
                    ))}
                    <th className="border border-gray-300 px-4 py-2 bg-thead text-left w-10">
                      Valorisation
                    </th>
                    <th className="border border-gray-300 px-4 py-2 bg-thead text-left w-10">
                      Taux horaire
                    </th>
                    <th className="border border-gray-300 px-4 py-2 bg-thead text-left w-10">
                      Commentaire
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {uniqueUsers.map((user: string, userIndex: number) => {
                    const collabData = mission?.collaborators?.find(
                      (collab: any) => collab.name === user
                    );

                    return collabData?.times?.map(
                      (time: any, timeIndex: number) => (
                        <tr
                          key={`${missionIndex}-${userIndex}-${timeIndex}`}
                          className="h-auto min-h-8"
                        >
                          <td className="w-10 border border-gray-300 px-4 py-2"></td>
                          {uniqueUsers.map((u: string) => (
                            <td
                              key={`${missionIndex}-${userIndex}-${u}`}
                              className="border border-gray-300 px-4 py-2 text-left w-10"
                            >
                              {u === user ? time.hours : ""}
                            </td>
                          ))}
                          <td className="border border-gray-300 px-4 py-2 text-left w-10">
                            {time.valorisation}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-left w-10">
                            {time.hourlyRate}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-left w-10">
                            {time.comment}
                          </td>
                        </tr>
                      )
                    );
                  })}
                  
                  {/* Ligne de total pour cette mission */}
                  <tr className="h-8 bg-gray-100">
                    <td className="w-44 border border-gray-300 px-4 py-2">
                      Total
                    </td>
                    {uniqueUsers.map((user: string) => {
                      const collab = mission.collaborators.find(
                        (c: any) => c.name === user
                      );
                      return (
                        <td
                          key={`${missionIndex}-${user}`}
                          className="border border-gray-300 px-4 py-2 text-left w-10"
                        >
                          {collab?.totalHours || ""}
                        </td>
                      );
                    })}
                    <td className="border border-gray-300 px-4 py-2 text-left w-10">
                      {mission.totalValorisation}
                    </td>
                    <td className="border border-gray-300 px-4 py-2 text-left w-10"></td>
                    <td className="border border-gray-300 px-4 py-2 text-left w-10"></td>
                  </tr>
                </tbody>
              </table>
          ))}
        </div>
      ))}
    </div>
  );
};

export default DetailsOfService;
